import React from 'react';
import JobCategoryPage from './JobCategoryPage';
import { Shield } from 'lucide-react';

const ForensicSocialWorkerJobs = () => {
  return (
    <JobCategoryPage
      category="forensic-social-worker-jobs"
      categoryFilter="forensic_public_safety"
      title="Forensic, Public Safety & Criminal Justice Social Work Jobs"
      metaTitle="Forensic & Public Safety Social Worker Jobs | INeedASocialWorker.com"
      metaDescription="Forensic, police, court, corrections, victim services, and crisis co-responder social work jobs nationwide. LCSW, LMSW, and LBSW roles in the justice system."
      heroTitle="Forensic, Public Safety & Criminal Justice Social Work"
      heroSubtitle="Police co-responder, court, corrections, reentry, victim services, juvenile justice, forensic mental health, and child advocacy roles for licensed social workers."
      searchKeywords={['forensic social worker', 'victim advocate', 'co-responder clinician', 'court social worker', 'crisis intervention']}
      iconComponent={Shield}
      contentSections={[
        {
          title: 'A Growing, Mission-Driven Field',
          content: 'Forensic and public-safety social workers serve at the intersection of behavioral health and the justice system — embedded with police as co-responders, in courts and jails, in victim-services units, and on mobile crisis teams. Demand is rising fast as cities and counties expand behavioral-health response and diversion programs.',
          list: [
            'Police & public-safety co-responder teams',
            'Courts, mitigation, and legal-services social work',
            'Corrections, jail, and reentry support',
            'Victim services and family-violence advocacy',
            'Juvenile justice and child forensic advocacy',
            'Forensic mental health and crisis response',
          ],
        },
        {
          title: 'Who Hires',
          content: 'Employers span city and county government, police and sheriff departments, district attorney and public defender offices, correctional facilities, nonprofits, hospitals, and federal agencies. Many roles are with government employers and are applied to on the official employer or USAJobs site.',
        },
        {
          title: 'Licensing',
          content: 'Clinical roles typically require an LCSW; many co-responder, advocacy, and case-management roles accept LMSW or LBSW. Crisis-intervention training and experience with trauma-informed care are highly valued.',
        },
      ]}
      relatedCategories={[
        { name: 'Behavioral Health Social Worker Jobs', href: '/behavioral-health-social-worker-jobs' },
        { name: 'Community & Government Jobs', href: '/community-social-worker-jobs' },
        { name: 'Clinical (LCSW) Jobs', href: '/clinical-social-worker-jobs' },
      ]}
    />
  );
};

export default ForensicSocialWorkerJobs;
